<template>
  <div class="ride-select-panel">
    <div class="wrapper" :class="$store.state.theme">
      <!-- <div v-if="!selected" class="going-to notification is-warning">
        Going to
        <button class="delete is-medium is-pulled-right" />
      </div> -->
      <div
        v-if="hasActiveRides"
        class="ongoing-bookings"
        @click="goto('orders')"
      >
        <i class="tag is-info pulse">You have an ongoing booking</i>
      </div>
      <div v-if="selected" class="field is-grouped where-to">
        <div class="field has-addons is-expanded">
          <div class="control is-expanded">
            <input
              class="input is-success"
              :placeholder="whereToText"
              @click="whereTo"
              readonly
            />
          </div>
          <div class="control">
            <button class="button is-success" @click="whereTo">
              <i class="far fa-clock" />
              &nbsp;{{ $t("now") }}
            </button>
          </div>
        </div>
        <div v-if="hasTours" class="control">
          <button
            class="button is-primary has-text-weight-semibold"
            disabled
            @click="tours"
          >
            {{ $t("ride.tours") }}
          </button>
        </div>
      </div>
      <div v-else class="choose-transport">
        <span v-if="hasTransport">
          {{ $t("ride.choose-your-transport") }}
          <span class="options is-pulled-right" @click="autoscroll">
            {{ transportTypes.length + 1 }} {{ $t("options") }}
          </span>
        </span>
        <span v-else>{{ $t("ride.not-yet-available") }}</span>
      </div>

      <hr style="margin: 10px 0" />

      <fade-transition group>
        <div v-if="selected" class="selected-transport" :key="1">
          <!-- <button
            class="delete is-medium is-pulled-right"
            @click="selectTransport(null)"
          /> -->
          <div class="is-flex">
            <div style="flex-shrink: 1; line-height: 100px">
              <i
                class="fa fa-chevron-left fa-lg"
                @click="selectTransport(null)"
              />
            </div>
            <div class="left" @click="whereTo">
              <p style="margin-bottom: -10px">
                <img :src="vehicleIcon(selected.name)" />
              </p>
              <p v-if="selectedPrivate" class="tag">
                <span v-if="selected.business.name.length > 15">
                  <marquee scrollamount="3">
                    <span class="marquee>">{{ selected.business.name }}</span>
                  </marquee>
                </span>
                <span v-else>{{ selected.business.name }}</span>
              </p>
              <p v-else class="tag">
                {{ $t("ride.max-x-passengers", { x: maxPax(selected) }) }}
              </p>
            </div>
            <div class="right">
              <p class="label">{{ translateTransportType(selected.name) }}</p>
              <p class="blurb" v-html="selectedBlurb" @click="whereTo"></p>
            </div>
          </div>
        </div>
        <div
          v-else
          class="transport-list-wrapper no-scrollbar"
          ref="scrollable"
          :key="2"
          v-on:scroll.passive="scroll = false"
        >
          <div class="transport-list">
            <!-- Add some padding to left if more than 2 public transport types -->
            <div
              v-if="transportTypes.length > 2"
              style="width: 15px; display: inline-block"
            />
            <!-- If you have a private transport set -->
            <div
              v-if="yourPrivateTransport"
              class="item"
              @click="gotoPrivateTransport"
            >
              <div class="circle-background">
                <div class="vehicle-type">
                  <img :src="vehicleIcon(ypt.name)" />
                </div>
              </div>
              <div class="transport-info">
                <p style="line-height: 1.15; min-height: 35px">
                  {{ shortenString(ypt.business.name, 25) }}
                </p>
                <p style="margin-top: -5px">
                  <span class="max-pax select-tag">{{
                    $t("ride.private")
                  }}</span>
                </p>
              </div>
            </div>

            <!-- Public transport options in your area -->
            <div
              v-for="t in transportTypes"
              :key="t.name"
              class="item"
              @click="selectTransport(t)"
            >
              <div class="circle-background">
                <div class="vehicle-type">
                  <img :src="vehicleIcon(t.name)" />
                </div>
              </div>
              <div class="transport-info">
                <p>{{ translateTransportType(t.name) }}</p>
                <p class="subname">{{ t.name }}</p>
                <p style="margin-top: -10px">
                  <span class="max-pax">
                    <i class="fa fa-user fa-sm" />
                    x{{ maxPax(t) }}
                  </span>
                </p>
              </div>
            </div>

            <!-- If you don't have a private transport set -->
            <div
              v-if="!yourPrivateTransport"
              class="item"
              @click="showPrivateTransportList = true"
            >
              <div class="circle-background">
                <div class="vehicle-type">
                  <img :src="vehicleIcon('Private Building')" />
                </div>
              </div>
              <div class="transport-info">
                <p>{{ $t("ride.private") }}</p>
                <p class="subname">{{ $t("ride.transport") }}</p>
                <p style="margin-top: -10px">
                  <span class="max-pax select-tag">{{ $t("select") }}</span>
                </p>
              </div>
            </div>

            <div v-if="!hasTransport" class="item" @click="contactUs">
              <div class="circle-background">
                <div class="vehicle-type">
                  <img :src="vehicleIcon('Horse Cart')" />
                </div>
              </div>
              <div class="transport-info">
                <p>{{ $t("contact-us") }}</p>
                <p class="subname">{{ $t("ride.your-fleet") }}</p>
                <p style="margin-top: -10px">
                  <span class="max-pax free-tag">
                    <i class="fa fa-tag fa-sm" />&nbsp;{{ $t("free") }}
                  </span>
                </p>
              </div>
            </div>
            <div
              v-if="scroll && transportTypes.length > 2"
              class="more-arrow"
            />

            <!-- Add some padding to right if more than 2 public transport types -->
            <div
              v-if="transportTypes.length > 2"
              style="width: 15px; display: inline-block"
            />
          </div>
        </div>
      </fade-transition>
    </div>

    <slide-y-down-transition>
      <RideWhereTo
        v-if="showFormType === 'normal'"
        :workflow="selected"
        @close="closeRideForm"
      />
    </slide-y-down-transition>

    <slide-y-down-transition>
      <RideWhereToPrivate
        v-if="showFormType === 'private' && selected"
        :workflow="selected"
        @close="closeRideForm"
        @clearSelected="
          selectTransport(null);
          showPrivateTransportList = true;
        "
      />
    </slide-y-down-transition>

    <slide-y-down-transition>
      <RidePrivateTransportList
        v-if="showPrivateTransportList"
        @close="closePrivateTransportList"
      />
    </slide-y-down-transition>
  </div>
</template>

<script>
import vehicles from "@/vehicles"; // vehicles.img("Balloon")
import EventBus from "../eventBus";

import RideWhereTo from "@/components/RideWhereTo.vue";
import RideWhereToPrivate from "@/components/RideWhereToPrivate.vue";
import RidePrivateTransportList from "@/components/RidePrivateTransportList.vue";

export default {
  name: "RideSelectPanel",
  components: {
    RideWhereTo,
    RideWhereToPrivate,
    RidePrivateTransportList,
  },
  props: {
    transport: Array, // transport workflows from getTransportNearby
  },
  data() {
    return {
      selected: null, // name of transport type, Sii Lor etc
      showFormType: null,
      showPrivateTransportList: false,
      timer: null,
      testTransportTypes: [
        { name: "Sii Lor", max_pax: 5 },
        { name: "Ka Po", max_pax: 9 },
      ],
      scroll: true,
      scrollPosition: 0,
    };
  },
  computed: {
    transportTypes() {
      if (!this.transport) this.testTransportTypes;
      var active = this.transport.filter((t) => t.state !== "inactive");
      return [
        // this.transport.find((t) => t.name === "Sii Lor"),
        // this.transport.find((t) => t.name === "Public Tuk Tuk"),
        // this.transport.find((t) => t.name === "Motorbike"),
        // this.transport.find((t) => t.name === "Taxi"),
        // this.transport.find((t) => t.name === "VIP Taxi"),
        // this.transport.find((t) => t.name === "Car"), // or private car?
        // this.transport.find((t) => t.name === "Songthaew"),
        // this.transport.find((t) => t.name === "Van"),
        active.find((t) => t.name === "Sii Lor"),
        active.find((t) => t.name === "Public Tuk Tuk"),
        active.find((t) => t.name === "Motorbike"),
        active.find((t) => t.name === "Taxi"),
        active.find((t) => t.name === "VIP Taxi"),
        active.find((t) => t.name === "Car"), // or private car?
        active.find((t) => t.name === "Songthaew"),
        active.find((t) => t.name === "Van"),
      ].filter((t) => t); // removes any nulls
    },
    hasTransport() {
      return this.transportTypes.length;
    },
    activeRides() {
      return this.$store.getters.getActiveRideTransactions; // ongoing transport transactions not ended
    },
    hasActiveRides() {
      return this.activeRides.length; // return this.$store.getters.getOngoingCustomerTransactions.length;
    },
    selectedPrivate() {
      var privateTypes = ["Private", "Tuk Tuk"];
      return privateTypes.includes(this.selected.name);
    },
    whereToText() {
      var privateTypes = ["Private", "Tuk Tuk"];
      if (privateTypes.includes(this.selected.name)) {
        return this.$t("ride.go-to-x", { x: this.selected.business.name });
      }
      return this.$t("where-to");
    },
    hasTours() {
      var transportType = this.selected.name;
      var workflows = this.transport.filter((t) => t.name === transportType);
      return workflows.find(
        (w) => w.data.tours_hourly || w.data.tours_itinerary
      );
    },
    yourPrivateTransport() {
      return this.$store.state.yourPrivateTransport;
    },
    ypt() {
      return this.$store.state.yourPrivateTransport;
    },
    selectedBlurb() {
      if (!this.selected.data.blurb) {
        var str = this.selected.name;
        var transportName = str.toLowerCase().replace(/\s+/g, "-");
        return this.$t(`transport-blurbs.${transportName}`);
      }
      return this.selected.data.blurb;
    },
  },
  mounted() {
    // if state.selectedTukTuk exists, then automatically select it if state.yourPrivateTransport not set
    this.migrateOldPrivateTukTuk();
    this.updatePrivateTransport();
    EventBus.$on("RIDE_WHERE_TO_CLEAR_TIMEOUT", () => clearTimeout(this.timer));
  },
  activated() {
    if (this.hasActiveRides) {
      console.log("redirect from /ride to /ride_booking", this.activeRides);
      var t = this.activeRides[0]; //this.$store.getters.getOngoingCustomerTransactions[0];
      this.goto("ride_booking/" + t.id);
    }
  },
  methods: {
    migrateOldPrivateTukTuk() {
      if (this.$store.state.yourPrivateTransport) return; // already set, skip
      if (!this.$store.state.selectedTukTuk) return; // no old one, skip
      var id = this.$store.state.selectedTukTuk.id;
      var transport = this.$store.state.transport.find((t) => t.id === id);
      if (transport) this.$store.commit("setPrivateTransport", transport);
    },
    closeRideForm() {
      this.showFormType = null;
      clearTimeout(this.timer);
    },
    updatePrivateTransport() {
      if (!this.yourPrivateTransport) return;
      this.$store
        .dispatch("getWorkflowByID", this.yourPrivateTransport.id)
        .then((res) => {
          this.console("getWorkflowByID", res);
          // this.$store.commit("updateSelectedTransport", res);
          // this.$store.commit("selectTransport", res);
          this.$store.commit("setPrivateTransport", res);
        });
    },
    autoscroll() {
      if (this.scrollPosition) this.scrollPosition = 0;
      else this.scrollPosition = 1000; // large number to scroll all the way
      var opts = { left: this.scrollPosition, behavior: "smooth" };
      this.$refs.scrollable.scrollTo(opts);
    },
    maxPax(transport) {
      var t = transport;
      if (t.data.max_pax) return t.data.max_pax;
      var name = t.name;
      if (name === "Motorbike") return 1;
      if (name === "Songthaew") return 9;
      if (name === "Sii Lor") return 6;
      if (name === "Taxi") return 4;
      return 4; // default
    },
    contactUs() {
      var msg = `Cool! 👍🏼<br>We're going to send you<br>over to our customer service<br>to help you get set up.`;
      this.infoToast(msg);
      setTimeout(() => window.open("https://m.me/tukapp", "_blank"), 3500);
    },
    closePrivateTransportList() {
      this.showPrivateTransportList = false;
      if (this.yourPrivateTransport) this.gotoPrivateTransport();
    },
    gotoPrivateTransport() {
      this.selected = this.yourPrivateTransport;
      // this.showFormType = "private";
      this.timer = setTimeout(() => (this.showFormType = "private"), 3000);
      this.$emit("select", this.selected);
    },
    selectTransport(t) {
      this.selected = t;
      this.$emit("select", this.selected);
      if (this.selected) {
        // if (this.selected.workflow_type_name === "Private Tuk Tuk") {
        //   if (this.checkYourPrivateTransport()) return;
        // }
        this.timer = setTimeout(() => this.whereTo(), 3000);
      } else clearTimeout(this.timer);
      // emit to parent Ride.vue so map can show transport vehicles
    },
    checkYourPrivateTransport() {
      if (!this.$store.state.checkYourPrivateTransport) {
        this.showPrivateTransportList = true;
        return true;
      }
      return false;
    },
    vehicleIcon(name) {
      if (!name) return vehicles.img("Balloon");
      return vehicles.img(name);
    },
    // setLocation(val) {
    //   this.console("setLocation", val);
    //   if (!val) return this.createCMTuktukTransaction(); // means skip, I think deprecated
    //   if (val.stop_type === "pickup") {
    //     this.pickup = this.setStop(val);
    //     if (this.validSpecialStop(this.pickup)) this.confirmPickup();
    //     else this.pickup = null;
    //   }
    //   if (val.stop_type === "dropoff") {
    //     this.dropoff = this.setStop(val);
    //     if (this.invalidDropoff()) return;
    //     this.confirmTransactionDetails();
    //   } // could re-arrange this, don't need both if-statements
    // },
    whereTo() {
      if (this.selected.workflow_type_name === "Private Tuk Tuk")
        this.showFormType = "private";
      else this.showFormType = "normal";
    },
    // popupTuktukOrSiilor() {
    //   if (this.$store.state.isWorking) return; // don't popup if working
    //   // if (!this.$store.getters.isLoggedIn) return this.setDefault();
    //   var selectedType = this.$store.state.selectedTransportType;
    //   if (selectedType === "privatetuk") this.useTuktuk();
    //   else if (selectedType === "localtuk") this.useSiilor();
    //   else if (selectedType === "motocy") this.useMotocy();
    //   else this.useSiilor();
    // },
    // selectTuktuk() {
    //   this.$store.commit("clearTukTuk"); // clear selectedTuktuk first
    //   console.log("clearTuktuk");
    //   this.bookTuktuk(); // if tuktuk has been cleared shows list of private tuks
    // },
    // useTuktuk() {
    //   this.$store.commit("setTransportType", "privatetuk");
    //   if (this.$store.state.selectedTukTuk) {
    //     this.$store.commit("selectTransport", this.$store.state.selectedTukTuk);
    //     this.bookTuktuk(); // show stops to book if tuktuk is selected
    //   } else {
    //     this.selectTuktuk();
    //   }
    // },
    tours() {
      // TODO (send to a new tours page or the type form)
    },
    // useSiilor() {
    //   this.$store.commit("setTransportType", "localtuk");
    //   this.bookSiilor();
    // },
    // bookTuktuk() {
    //   if (!this.$store.state.selectedTukTuk) {
    //     console.log("tuktuk-select-modal");
    //     this.updateRoles(false);
    //     EventBus.$emit("REFRESH_TUKTUK_SELECT");
    //     this.displayModal(".tuktuk-select-modal");
    //     return;
    //   }
    //   if (this.$store.state.selectedTukTuk.data.dropoff_only) {
    //     EventBus.$emit("REFRESH_PRIVATETUK_MODAL2");
    //     this.$nextTick(() => this.displayModal(".tuktuk-request-modal2"));
    //   } else {
    //     EventBus.$emit("REFRESH_PRIVATETUK_MODAL");
    //     this.$nextTick(() => this.displayModal(".request-tuktuk-modal"));
    //   }
    // },
    // bookSiilor() {
    //   if (this.loginOkay(this.$t("login.login-to-use-siilor"))) {
    //     this.console("bookSiilor", this.$store.getters.getSiilors);
    //     if (this.$store.getters.getSiilor == []) {
    //       this.$swal({
    //         type: "info",
    //         text: "Sii lor is not yet available in your area",
    //       });
    //       return;
    //     }
    //     // var siilor = this.$store.getters.getSiilor;
    //     var siilor = this.getClosestSiilor();
    //     this.$store.commit("selectTransport", siilor); // siilor is transport not private tuk
    //     EventBus.$emit("REFRESH_SIILOR_MODAL");
    //     this.$nextTick(() => this.displayModal(".siilor-request-modal"));
    //   }
    // },
    // getClosestSiilor() {
    //   var siilors = this.$store.getters.getSiilors; // sort these by distance
    //   var coords = this.$store.getters.getUserLocation;
    //   if (!coords) return;
    //   var userLoc = { lat: coords[0], lon: coords[1] };
    //   siilors.forEach((w) => {
    //     w.distance = geo.distanceToUserInMeters(w.business, userLoc);
    //     w.distancePretty = geo.prettyDistance(w.distance);
    //     this.console("siilor distance added", w);
    //   });
    //   siilors.sort((a, b) => {
    //     return a.distance - b.distance;
    //   });
    //   this.$store.commit("setNearbySiilors", siilors.slice(1, siilors.length));
    //   this.console(`closest of ${siilors.length} siilor stations`, siilors[0]);
    //   return siilors[0]; // this should be closest one
    // },
    // getClosestWorkflow(workflows) {
    //   var coords = this.$store.getters.getUserLocation;
    //   if (!coords) return;
    //   var userLoc = { lat: coords[0], lon: coords[1] };
    //   workflows.forEach((w) => {
    //     w.distance = geo.distanceToUserInMeters(w.business, userLoc);
    //     w.distancePretty = geo.prettyDistance(w.distance);
    //     this.console("workflow distance added", w);
    //   });
    //   workflows.sort((a, b) => {
    //     return a.distance - b.distance; // sort these by distance
    //   });
    //   return workflows; //workflows[0]; // this should be closest one
    // },
  },
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 200px; /* 215px; needed to hard-code height */
  width: 100vw;
  background-color: white;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.2);
  /* z-index: 1; */
}
/* .dark {
  background-color: rgba(17, 34, 51, 0.85);
  color: white;
} */
.choose-transport {
  position: relative;
  font-size: 1.2em;
  font-weight: 500;
  opacity: 0.8;
  text-align: left;
  padding: 4px;
  margin: 10px;
}
.ongoing-bookings {
  position: relative;
  top: -34px;
  left: 10px;
  height: 0px;
  width: 0px;
  font-weight: 500;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }
  100% {
    box-shadow: 0 0 0 6px rgba(247, 211, 8, 0.5);
  }
}
.pulse {
  animation: shadow-pulse 1s 999;
}
.options {
  color: grey;
  opacity: 0.7;
  font-size: 0.8em;
  margin-top: 3px;
  cursor: pointer;
}
.where-to {
  margin: 10px;
}
.max-passengers {
  border-radius: 50%;
  width: 80px;
  /* height: 70px; */
  background-color: white;
  font-weight: bold;
  font-size: 0.7em;
  color: grey;
}
.select-tag {
  /* background-color: rgb(51, 219, 51) !important; */
  background-color: rgb(126, 169, 247);
  color: white !important;
}
.free-tag {
  background-color: rgb(253, 54, 54) !important;
  color: white !important;
}
.max-pax {
  border-radius: 10px;
  padding: 0 6px;
  /* background-color: rgb(126, 169, 247); */
  font-weight: bold;
  font-size: 0.7em;
  /* opacity: 0.7; */
  /* color: white; */
  /* color: rgb(126, 169, 247); */
  color: grey;
}
.circle-background {
  border-radius: 50%;
  width: 80px;
  height: 50px;
  background-color: rgba(173, 216, 230, 0.5);
  font-size: 0.9em;
  display: inline-block;
}
.transport-info {
  margin-top: -25px;
  /* height: 200px; */
}
.opaque {
  opacity: 0.4;
}
.vehicle-type {
  position: relative;
  top: -15px;
  /* height: 150px; */
}
.transport-list img {
  transform: scale(0.9);
}
img {
  min-height: 60px;
  -webkit-filter: drop-shadow(2px 2px 2px #666);
  filter: drop-shadow(2px 2px 2px #666);
}
.field {
  margin-bottom: 0;
}
.subname {
  font-size: 0.7em;
  position: relative;
  top: -4px;
  font-weight: 600;
  color: grey;
}
.selected-transport {
  padding: 0 12px;
  text-align: left;
  /* background-color: rgba(164, 222, 240, 0.5); */
  /* margin: 10px; */
  /* border-radius: 4px; */
}
.selected-transport img {
  height: 100px;
  width: auto;
  /* margin-top: -16px; */
  margin-top: -8px;
}
.left {
  flex: 0.6;
  text-align: center;
  /* max-width: 100px; */
}
.right {
  /* padding: 10px; */
  margin-left: 16px;
  flex: 1;
}
.transport-list-wrapper {
  /* width: 100%; */
  /* width: 100%; */
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  /* vertical-align: top; */
  /* display: inline-block; */
}
/* .transport-list { */
/* vertical-align: top; */
/* width: 100%; */
/* display: flex; */
/* flex-wrap: wrap; */
/* flex: 0 0 auto; */
/* flex-basis: 0; */
/* flex-grow: 2; */
/* justify-content: space-evenly; */
/* align-items: center; */
/* justify-content: center; */

/* justify-content: space-around; */
/* } */
.item {
  vertical-align: top;
  display: inline-block;
  /* flex: 1; */
  /* height: 300px !important; */
  width: 115px;
  white-space: normal;
  /* margin-bottom: 200px;
  padding-bottom: 200px; */
  /* text-align: center; */
}
.last-item {
  margin-right: 15px;
}
/* .marquee { */
/* display: inline-block;
  vertical-align: bottom; */
/* width: 100px; */
/* } */
input::-webkit-input-placeholder {
  /* color: #2693da !important; */
  /* color: #24d168 !important; */
  color: #222;
  opacity: 0.8;
  font-weight: 550;
}
.more-arrow {
  position: fixed;
  right: 0px;
  bottom: 92px;
  width: 1px;
  height: 30px;
  border-radius: 50%;
  background-color: gold;
  animation: shadow-pulse-gold 2s infinite;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px gold;
  }
  100% {
    box-shadow: 0 0 0 10px rgba(255, 217, 0, 0.7);
  }
}
.going-to {
  position: absolute;
  top: -30px;
  left: 0;
  width: 100vw;
  padding: 6px 14px;
  text-align: left;
  /* z-index: 0; */
  font-size: 1.2em;
  font-weight: 500;
  border-radius: 0;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.2);
}
.back-btn {
  position: absolute;
  left: 0;
  padding-left: 10px;
  padding-top: 2px;
  font-size: 1.6em;
}
.blurb {
  font-weight: 450;
  color: #777;
}
</style>